import { AxiosError } from 'axios';

/** Extract a human-readable message from an axios/API error. */
export function getApiErrorMessage(error: unknown, fallback = 'An unexpected error occurred'): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as
      | { message?: string | string[] | { message?: string; code?: string }; error?: string }
      | undefined;

    const message = data?.message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
    if (Array.isArray(message) && message.length > 0) {
      return message.join(', ');
    }
    if (
      message &&
      typeof message === 'object' &&
      !Array.isArray(message) &&
      typeof message.message === 'string' &&
      message.message.trim()
    ) {
      return message.message;
    }
    if (typeof data?.error === 'string' && data.error.trim()) {
      return data.error;
    }

    if (error.code === 'ECONNABORTED') {
      return 'Request timed out. Please try again.';
    }
    if (!error.response) {
      return 'Network error. Check your connection and try again.';
    }
    if (error.response.status === 401) {
      return 'Your session expired. Please sign in again.';
    }
    if (error.response.status === 403) {
      return 'You do not have permission to perform this action.';
    }
    if (error.response.status >= 500) {
      return 'Something went wrong on the server. Please try again.';
    }
    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}
